(() => {
  const mount = () => document.querySelectorAll('[data-round-product]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('.or-form');
    const packs = [...root.querySelectorAll('[data-round-pack]')];
    const sync = () => {
      const pack = packs.find(p => p.checked);
      if (!pack) return;
      root.querySelector('[data-round-price]').textContent = pack.dataset.money;
      root.querySelector('[data-round-sticky-price]').textContent = `${pack.dataset.money} · ${pack.dataset.packName}`;
    };
    packs.forEach(p => p.addEventListener('change', sync));
    root.querySelectorAll('[data-round-select]').forEach(a => a.addEventListener('click', () => {
      const p = packs.find(p => p.value === a.dataset.roundSelect);
      if (p) { p.checked = true; sync(); }
    }));
    root.querySelectorAll('[data-round-thumb]').forEach(button => button.addEventListener('click', () => {
      const img = root.querySelector('[data-round-image]');
      img.src = button.dataset.src; img.alt = button.dataset.alt;
      root.querySelectorAll('[data-round-thumb]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    }));
    const sticky = root.querySelector('[data-round-sticky]');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      }, {threshold: 0});
      observer.observe(root.querySelector('.or-hero'));
    }
    root.querySelector('[data-round-submit]')?.setAttribute('aria-haspopup', 'dialog');
    form?.addEventListener('submit', async event => {
      event.preventDefault();
      const button = root.querySelector('[data-round-submit]');
      const message = root.querySelector('[data-round-message]');
      if (button.disabled) return;
      let added = false;
      button.disabled = true; button.setAttribute('aria-busy', 'true'); message.textContent = 'Adding your pack…';
      try {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function') {
          throw new Error('Please reload the page and try again.');
        }
        const data = new FormData(form);
        const sections = drawer.getSectionsToRender().map(section => section.id);
        data.set('sections', sections.join(','));
        data.set('sections_url', window.location.pathname);
        drawer.setActiveElement(button);
        const base = window.Shopify?.routes?.root || '/';
        const response = await fetch(base + 'cart/add.js', {
          method: 'POST', body: data,
          headers: {'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest'}
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          throw new Error(result.description || 'This item is not available to order.');
        }
        added = true;
        // A successful cart add can return null sections. Refresh without adding twice.
        if (sections.some(id => !result.sections?.[id])) {
          const url = new URL(window.location.href);
          url.searchParams.set('sections', sections.join(','));
          const refresh = await fetch(url, {headers: {'Accept': 'application/json'}});
          if (!refresh.ok) throw new Error('Cart refresh failed.');
          result.sections = await refresh.json();
          if (sections.some(id => !result.sections?.[id])) throw new Error('Cart refresh failed.');
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
        }
        drawer.renderContents(result);
        message.textContent = '';
      } catch (error) { message.textContent = added ? 'Your pack was added. Reload the page to view your updated cart.' : (error.message || 'Please try again or contact support.'); }
      finally { button.disabled = false; button.removeAttribute('aria-busy'); }
    });
    sync();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
  document.addEventListener('shopify:section:load', mount);
})();
